import React from "react";
import { parseMessageContent } from "~/functions/messageContent";

export default function MessageContent({ body, className = "" }) {
  return <div className={"whitespace-pre-wrap break-words " + className}>
    {parseMessageContent(body).map((node, index) => node.type === "text" ? node.text :
      <a key={index} href={node.url} target="_blank" rel="noopener noreferrer" className="text-orange-700 underline">{node.label}</a>)}
  </div>;
}
